import React, { useState, useEffect } from 'react';
import { Edit, Trash2, Eye } from 'lucide-react';
import formComplaintsService from '../services/formService';
import emailService from '../services/email';
import '../styles/form.css';
import authService from '../services/loginService';

const QuejasYSugerencias = () => {
  const [filtroEstado, setFiltroEstado] = useState('');
  const [respuesta, setRespuesta] = useState('');
  //const [nombreOperador, setNombreOperador] = useState('');
  const [registros, setRegistros] = useState([]);
  const [mensajeSeleccionado, setMensajeSeleccionado] = useState('');
  const [formularioSeleccionado, setFormularioSeleccionado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [enviandoRespuesta, setEnviandoRespuesta] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const currentUser = authService.getCurrentUser();

  // Cargar formularios al iniciar
  useEffect(() => {
    cargarFormularios();
  }, []);

  const cargarFormularios = async () => {
    try {
      setLoading(true);
      const response = await formComplaintsService.getAllForms();
      setRegistros(response.forms || response || []);
      setMensaje('');
    } catch (error) {
      console.error('Error al cargar formularios:', error);
      setMensaje('Error al cargar los formularios');
    } finally {
      setLoading(false);
    }
  };

  // Filtrar registros por estado
  const registrosFiltrados = registros.filter(registro => {
    if (!filtroEstado) return true;
    return registro.status.toLowerCase().includes(filtroEstado.toLowerCase());
  });

  // Ver mensaje del formulario
  const verMensaje = async (registro) => {
    try {
      const response = await formComplaintsService.getFormById(registro._id);
      setMensajeSeleccionado(response.message || registro.message);
      setFormularioSeleccionado(registro);
    } catch (error) {
      console.error('Error al obtener mensaje:', error);
      setMensajeSeleccionado(registro.message);
      setFormularioSeleccionado(registro);
    }
  };

  // Enviar respuesta por email y finalizar formulario
  const enviarRespuesta = async () => {
    if (!formularioSeleccionado) {
      setMensaje('Debe seleccionar un formulario primero');
      return;
    }

    if (!respuesta.trim()) {
      setMensaje('Debe escribir una respuesta');
      return;
    }

    try {
      setEnviandoRespuesta(true);

      // Crear el HTML del email con formato profesional
      const htmlEmail = `
        <div style="font-family: 'Arial', sans-serif; max-width: 600px; margin: 0 auto; background-color: #f9f9f9; padding: 20px;">
          <div style="background-color: #ffffff; border-radius: 10px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); overflow: hidden;">
            <!-- Header -->
            <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 30px; text-align: center;">
              <h1 style="margin: 0; font-size: 28px; font-weight: 300;">EDINTEL</h1>
              <p style="margin: 10px 0 0 0; font-size: 16px; opacity: 0.9;">Respuesta a su ${formularioSeleccionado.type}</p>
            </div>
            
            <!-- Content -->
            <div style="padding: 40px 30px;">
              <div style="margin-bottom: 30px;">
                <h2 style="color: #333; font-size: 20px; margin-bottom: 15px; border-bottom: 2px solid #667eea; padding-bottom: 10px;">
                  Estimado/a usuario/a
                </h2>
                <p style="color: #666; line-height: 1.6; margin-bottom: 20px;">
                  Hemos recibido su ${formularioSeleccionado.type.toLowerCase()} y queremos agradecerle por tomarse el tiempo de contactarnos. 
                  Su opinión es muy importante para nosotros.
                </p>
              </div>

              <!-- Original Message -->
              <div style="background-color: #f8f9fa; border-left: 4px solid #667eea; padding: 20px; margin: 25px 0; border-radius: 0 8px 8px 0;">
                <h3 style="color: #333; font-size: 16px; margin: 0 0 10px 0;">Su mensaje original:</h3>
                <p style="color: #555; line-height: 1.6; margin: 0; font-style: italic;">
                  "${mensajeSeleccionado}"
                </p>
              </div>

              <!-- Response -->
              <div style="margin: 30px 0;">
                <h3 style="color: #333; font-size: 18px; margin-bottom: 15px;">Nuestra respuesta:</h3>
                <div style="background-color: #ffffff; border: 1px solid #e9ecef; border-radius: 8px; padding: 25px;">
                  <p style="color: #444; line-height: 1.7; margin: 0; white-space: pre-line;">
                    ${respuesta}
                  </p>
                </div>
              </div>

              <!-- Operator Info -->
              <div style="background-color: #f8f9fa; border-radius: 8px; padding: 20px; margin: 25px 0;">
                <p style="color: #666; margin: 0; font-size: 14px;">
                  <strong>Atendido por:</strong> ${currentUser.name} ${currentUser.lastname}<br>
                  <strong>Fecha:</strong> ${new Date().toLocaleString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })}<br>
                  <strong>Número de caso:</strong> #${formularioSeleccionado._id?.slice(-8) || '12345678'}
                </p>
              </div>

              <div style="text-align: center; margin-top: 30px;">
                <p style="color: #666; font-size: 14px; line-height: 1.6;">
                  Si tiene alguna pregunta adicional, no dude en contactarnos nuevamente.<br>
                  Gracias por confiar en nuestros servicios.
                </p>
              </div>
            </div>

            <!-- Footer -->
            <div style="background-color: #667eea; color: white; padding: 20px; text-align: center;">
              <p style="margin: 0; font-size: 14px; opacity: 0.9;">
                Este es un mensaje automático, por favor no responda a este correo.
              </p>
              <p style="margin: 5px 0 0 0; font-size: 12px; opacity: 0.7;">
                © 2025 EDINTEL. Todos los derechos reservados.
              </p>
            </div>
          </div>
        </div>
      `;

      // Texto plano como fallback
      const textoPlano = `
EDINTEL - Respuesta a su ${formularioSeleccionado.type}

Estimado/a usuario/a,

Hemos recibido su ${formularioSeleccionado.type.toLowerCase()} y queremos agradecerle por contactarnos.

Su mensaje original:
"${mensajeSeleccionado}"

Nuestra respuesta:
${respuesta}

Atendido por: ${currentUser.name} ${currentUser.lastname}
Fecha: ${new Date().toLocaleString('es-ES')}
Número de caso: #${formularioSeleccionado._id?.slice(-8) || '12345678'}

Si tiene alguna pregunta adicional, no dude en contactarnos nuevamente.
Gracias por confiar en nuestros servicios.

Este es un mensaje automático, por favor no responda a este correo.
© 2025 EDINTEL. Todos los derechos reservados.
      `;

      // Enviar email
      const emailResult = await emailService.sendEmail({
        to: formularioSeleccionado.email,
        subject: `EDINTEL - Respuesta a su ${formularioSeleccionado.type} #${formularioSeleccionado._id?.slice(-8) || '12345678'}`,
        text: textoPlano,
        html: htmlEmail
      });

      if (emailResult.success) {
        // Finalizar el formulario
        await formComplaintsService.finalizeForm(formularioSeleccionado._id, respuesta, currentUser.idCard);

        // Recargar la lista de formularios
        await cargarFormularios();

        // Limpiar campos
        setRespuesta('');
        setMensajeSeleccionado('');
        setFormularioSeleccionado(null);

        setMensaje('Respuesta enviada exitosamente y formulario finalizado');
      } else {
        throw new Error(emailResult.error || 'Error al enviar el email');
      }

    } catch (error) {
      console.error('Error al enviar respuesta:', error);
      setMensaje(`Error al enviar respuesta: ${error.message}`);
    } finally {
      setEnviandoRespuesta(false);
    }
  };

  // Eliminar formulario
  const eliminarFormulario = async (id) => {
    if (window.confirm('¿Está seguro de que desea eliminar este formulario?')) {
      try {
        // Aquí necesitarías implementar el método delete en tu service
        // await formComplaintsService.deleteForm(id);
        await cargarFormularios();
        setMensaje('Formulario eliminado exitosamente');
      } catch (error) {
        console.error('Error al eliminar formulario:', error);
        setMensaje('Error al eliminar el formulario');
      }
    }
  };

  return (
    <div className="quejas-main-container">
      {/* Header */}
      <div className="quejas-header-section">
        <h1 className="quejas-main-title">Formularios Quejas y Sugerencias</h1>
        {mensaje && (
          <div className={`alert ${mensaje.includes('Error') ? 'alert-error' : 'alert-success'}`}>
            {mensaje}
          </div>
        )}
      </div>

      <div className="quejas-content-wrapper">
        {/* Panel izquierdo */}
        <div className="quejas-left-panel">
          {/* Sección de filtros */}
          <div className="quejas-filter-section">
            <h2 className="quejas-section-title">Quejas/Sugerencias Registradas</h2>
            <div className="quejas-filter-container">
              <input
                type="text"
                placeholder="Filtrar por estado..."
                value={filtroEstado}
                onChange={(e) => setFiltroEstado(e.target.value)}
                className="quejas-filter-input"
              />
              <button
                className="quejas-filter-button"
                onClick={cargarFormularios}
                disabled={loading}
              >
                {loading ? 'Cargando...' : 'Actualizar'}
              </button>
            </div>
          </div>

          {/* Tabla de registros */}
          <div className="quejas-table-wrapper">
            {loading ? (
              <div className="loading-message">Cargando formularios...</div>
            ) : (
              <table className="quejas-data-table">
                <thead>
                  <tr className="quejas-table-header-row">
                    <th className="quejas-table-header-cell">Email</th>
                    <th className="quejas-table-header-cell">Estado</th>
                    <th className="quejas-table-header-cell">Tipo</th>
                    <th className="quejas-table-header-cell">Fecha</th>
                    <th className="quejas-table-header-cell">Mensaje</th>
                    <th className="quejas-table-header-cell">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {registrosFiltrados.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="no-data">No hay formularios disponibles</td>
                    </tr>
                  ) : (
                    registrosFiltrados.map((registro) => (
                      <tr key={registro._id} className="quejas-table-data-row">
                        <td className="quejas-table-data-cell">{registro.email}</td>
                        <td className="quejas-table-data-cell">
                          <span className={`status-badge status-${registro.status.toLowerCase()}`}>
                            {registro.status}
                          </span>
                        </td>
                        <td className="quejas-table-data-cell">{registro.type}</td>
                        <td className="quejas-table-data-cell">
                          {new Date(registro.timestamp).toLocaleDateString('es-ES')}
                        </td>
                        <td className="quejas-table-data-cell">
                          <button
                            className="quejas-view-button"
                            onClick={() => verMensaje(registro)}
                          >
                            <Eye size={16} /> Ver
                          </button>
                        </td>
                        <td className="quejas-table-data-cell">
                          <div className="quejas-action-buttons-group">
                            {registro.status !== 'Finalizado'

                            }
                            <button
                              className="quejas-delete-icon-button"
                              onClick={() => eliminarFormulario(registro._id)}
                            >
                              <Trash2 size={16} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            )}
          </div>

          {/* Sección de mensaje */}
          <div className="quejas-message-section">
            <h3 className="quejas-message-title">
              Mensaje {formularioSeleccionado && `(${formularioSeleccionado.type})`}
            </h3>
            <div className="quejas-message-display-box">
              {mensajeSeleccionado ? (
                mensajeSeleccionado.split('\n').map((line, index) => (
                  <div key={index} className="quejas-message-line">
                    {line}
                  </div>
                ))
              ) : (
                <div className="quejas-message-placeholder">
                  Seleccione "Ver" en un formulario para mostrar el mensaje
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Panel derecho */}
        <div className="quejas-right-panel">
          <h3 className="quejas-response-title">Responder</h3>

          <div className="quejas-operator-section">
            <label className="quejas-operator-label">Nombre del operador</label>
            <input
              type="text"
              value={currentUser.name +  currentUser.lastname}
              className="quejas-operator-input"
              readOnly
            />
          </div>
          {formularioSeleccionado && (
            <div className="selected-form-info">
              <p><strong>Respondiendo a:</strong> {formularioSeleccionado.email}</p>
              <p><strong>Tipo:</strong> {formularioSeleccionado.type}</p>
              <p><strong>Estado:</strong> {formularioSeleccionado.status}</p>
            </div>
          )}

          <div className="quejas-response-section">
            <textarea
              value={respuesta}
              onChange={(e) => setRespuesta(e.target.value)}
              className="quejas-response-textarea"
              placeholder="Escriba su respuesta aquí..."
              disabled={!formularioSeleccionado}
            />
          </div>

          <button
            className="quejas-save-button"
            onClick={enviarRespuesta}
            disabled={enviandoRespuesta || !formularioSeleccionado || !respuesta.trim()}
          >
            {enviandoRespuesta ? 'Enviando...' : 'Enviar Respuesta'}
          </button>

          {!formularioSeleccionado && (
            <p className="help-text">
              Seleccione un formulario y vea su mensaje para poder responder
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuejasYSugerencias;